import BubbleChild from "./styled-components/BubbleChild";
import BubbleParent from "./styled-components/BubbleParent";
import Container from "./styled-components/Container";
import FootprintDetails from "./styled-components/FootprintDetails";
import FootprintLabel from "./styled-components/FootprintLabel";
import FootprintResults from "./styled-components/FootprintResults";
import FootprintSeparator from "./styled-components/FootprintSeparator";
import FootprintValue from "./styled-components/FootprintValue";
import FootprintValueIndicator from "./styled-components/FootprintValueIndicator";

interface AverageFootprintProps {
  userFootprint: number;
  averageFootprint: number;
}

function AverageFootprint({
  userFootprint,
  averageFootprint,
}: AverageFootprintProps) {
  const isUserFootprintGreater = userFootprint > averageFootprint;
  const childPercentage = isUserFootprintGreater
    ? Math.round((averageFootprint / userFootprint) * 100)
    : Math.round((userFootprint / averageFootprint) * 100);

  return (
    <Container>
      <BubbleParent variant={isUserFootprintGreater ? "user" : "average"}>
        <BubbleChild
          size={childPercentage}
          variant={isUserFootprintGreater ? "average" : "user"}
        />
      </BubbleParent>
      <FootprintResults>
        <FootprintDetails>
          <FootprintValue>
            {userFootprint.toFixed(2)}&nbsp;
            <FootprintValueIndicator>
              tmCO<sub>2</sub>
            </FootprintValueIndicator>
          </FootprintValue>
          <FootprintLabel>Tu huella de carbono</FootprintLabel>
          <FootprintSeparator />
        </FootprintDetails>
        <FootprintDetails>
          <FootprintValue>
            {averageFootprint.toFixed(2)}&nbsp;
            <FootprintValueIndicator>
              tmCO<sub>2</sub>
            </FootprintValueIndicator>
          </FootprintValue>
          <FootprintLabel>Media de los ciudadanos</FootprintLabel>
          <FootprintSeparator />
        </FootprintDetails>
      </FootprintResults>
    </Container>
  );
}

export default AverageFootprint;
